import React from 'react'

import { BaseMDXLayout } from './base-mdx'
import { LandingLayoutGlobalStyle } from './landing.styles'

export const LandingLayout: React.FC = (props) => {
  const { children } = props

  return (
    <>
      <LandingLayoutGlobalStyle />
      <BaseMDXLayout>{children}</BaseMDXLayout>
    </>
  )
}

export default LandingLayout
